export const RecordVI = {
    "personnelRecord":"Hồ sơ nhân sự",
    "working":"Đang làm việc",
    "temporaryLeave":"Nghỉ tạm thời",
    "resignation":"Nghỉ việc",
    "laborContract":"Hợp đồng",
    "insurance":"Bảo hiểm",
    "competencyAssessment":"Đánh giá nhân sự",
    "decision":"Quyết định",
    "assessmentEmployee":"Phiếu đánh giá",
    "assessmentTemplate":"Mẫu đánh giá",
    "assessmentChilds":"Tiêu chí đánh giá",
    "estimatedIncreasing":"Tăng dự kiến",
    "estimatedDecreases":"Giảm dự kiến",
    "paymentHistory":"Lịch sử đóng",
    "dismissalDecision":"Quyết định miễn nhiệm",
    "terminationOfLaborContract":"Quyết định chấm dứt hợp đồng lao động",
    "salaryDecision":"Quyết định điều chỉnh lương",
    "rewardDecision":"Quyết định khen thưởng",
    "disciplineDecision":"Kỷ luật lao động",
    "transferDecision":"Quyết định điều chuyển",
    "admissionDecision":"Quyết định tiếp nhận",
    "appointmentDecision":"Quyết định bổ nhiệm",

}